export default __webpack_public_path__ + "static/media/apple_pie_snack.c1cfb5d7.jpg";